import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AmbienteService } from '../../../../../services/ambiente.service';
import { ToastService } from '../../../../../services/toast.service';
import { Ambiente } from '../../../../../types/Ambiente.type';
import { Base } from '../../../../../types/Base.type';
import { Cliente } from '../../../../../types/Cliente.type';
import { ClienteCompleto } from '../../../../../types/ClienteCompletoResponse.type';
import { Perfil } from '../../../../../types/Perfil.type';
import { Usuario } from '../../../../../types/Usuario.type';
import { UsuarioService } from '../../usuarios/usuario.service';
import { ClientesService } from '../clientes.service';

@Component({
  selector: 'app-clienteform',
  templateUrl: './clienteform.component.html',
  styleUrl: './clienteform.component.css',
})
export class ClienteformComponent implements OnInit {
  constructor(
    private clientService: ClientesService,
    private toastService: ToastService,
    private activatedRoute: ActivatedRoute,
    private ambienteService: AmbienteService,
    private usuarioService: UsuarioService,
    private route: Router
  ) {
    
  }

  cliente: ClienteCompleto = {} as ClienteCompleto;
  clienteCadastro: Cliente = {} as Cliente;

  baseSelecionada!: Base;

  ambientesClones: { [s: string]: Ambiente } = {};
  usuariosClones: { [s: string]: Usuario } = {};

  abreNovoAmbiente: boolean = false;
  abreUsuarioDialog: boolean = false;

  perfis: Perfil[] = []

  ngOnInit(): void {
    this.carregarCliente()
  }

  carregarCliente(){
    let id = this.activatedRoute.snapshot.paramMap.get('id');

    if (id) {
      this.clientService.getClienteCompleto(id!).subscribe({
        next: (valor) => {
          this.cliente = valor;
          // this.perfis = this.cliente.perfis
        },
      });
    }
  }

  editarAmbiente(ambiente: Ambiente) {
    this.ambientesClones[ambiente.id as string] = { ...ambiente };
  }

  atualizarAmbiente(ambiente: Ambiente) {
    this.ambienteService.put(ambiente).subscribe({
      next: () => {
        this.toastService.sucesso('Sucesso', 'Ambiente salvo com sucesso');
      },
      error: (value) => {
        this.toastService.erro(
          'Erro',
          'Erro ao salvar o ambiente, tente novamente: ' + value.error
        );
      },
    });
  }

  cancelarAmbiente(ambiente: Ambiente, id: number) {
    this.cliente.ambientes[id] = this.ambientesClones[ambiente.id as string];
    delete this.ambientesClones[ambiente.id as string];
  }

  abreNovoDialog() {
    this.abreNovoAmbiente = true;
  }

  escondeNovoDialog() {
    this.abreNovoAmbiente = false;

    let id = this.activatedRoute.snapshot.paramMap.get('id');

    this.clientService.getClienteCompleto(id!).subscribe({
      next: (valor) => {
        this.cliente = valor;
      },
    });
  }

  abreUsuario() {
    this.abreUsuarioDialog = true;
  }

  escondeUsuarioDialog() {
    this.abreUsuarioDialog = false;
  }

  salvar() {
    Object.assign(this.clienteCadastro, this.cliente);

    if (this.cliente.id) {
      this.clientService.put(this.clienteCadastro).subscribe({
        next: () => {
          this.toastService.sucesso(
            'Sucesso',
            'Cliente atualizado com sucesso'
          );
        },
        error: (value) => {
          this.toastService.erro('Erro', 'Erro ao salvar: ' + value);
        },
      });
    } else {
      this.clientService.post(this.clienteCadastro).subscribe({
        next: (valor) => {
          Object.assign(this.cliente, valor);
          this.toastService.sucesso('Sucesso', 'Cliente salvo com sucesso');
          // this.route.navigate(["editar", this.cliente.id])
        },
        error: (value) => {
          this.toastService.erro('Erro', 'Erro ao salvar: ' + value);
        },
      });
    }
  }


  editarUsuario(usuario: Usuario) {
    
    this.usuariosClones[usuario.id as string] = { ...usuario };
  }

  atualizarUsuario(usuario: Usuario) {
    
    this.usuarioService.put(usuario).subscribe({
      next: () => {
        this.toastService.sucesso('Sucesso', 'Usuário salvo com sucesso');
        this.carregarCliente();
      },
      error: (value) => {
        this.toastService.erro(
          'Erro',
          'Erro ao salvar o usuário, tente novamente: ' + value.error
        );
      },
    });
  }

  cancelarUsuario(usuario: Usuario, id: number) {
    this.cliente.usuarios[id] = this.usuariosClones[usuario.id as string];
    delete this.usuariosClones[usuario.id as string];
  }

  desativarUsuario(usuario: Usuario){
    this.usuarioService.delete(usuario.id).subscribe({
      next: () => {
        this.toastService.sucesso("Sucesso", "Usuário desativado")
      },
      error: (error) => {
        this.toastService.erro("Erro", "Erro ao desativar: " + error)
      },
      complete: () => {
        this.carregarCliente()
      }
    })
  }

  ativarUsuario(usuario: Usuario){
    this.usuarioService.ativar(usuario.id).subscribe({
      next: () => {
        this.toastService.sucesso("Sucesso", "Usuário ativado")
      },
      error: (error) => {
        this.toastService.erro("Erro", "Erro ao ativar: " + error)
      },
      complete: () => {
        this.carregarCliente()
      }
    })
  }
}
